module.exports = __webpack_public_path__ + "img/document-big.3b9a80c6.svg";